import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  primaryFont: '"Montserrat", sans-serif',
};

export default theme;
